import React, { useEffect, useState } from 'react';
import MainDashboard from './main-dashboard';
import TransactionChart from './transaction-chart';
import Insight from './insights';
import PageHeader from 'components/base/page-header';
import useDashboardContext from 'contexts/dashboard.context';
import {
  DateRangeType,
  ENUM_DATE_RANGE,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';

const Dashboard = () => {
  const { monthlyStat, monthlyStatLoading, companyWalletDetails, setIsBackLink } =
    useDashboardContext();
  const [dateRange, setDateRange] = useState<DateRangeType>({
    date: getDateRangeSelector(ENUM_DATE_RANGE.THIS_WEEK),
    range: ENUM_DATE_RANGE.THIS_WEEK
  });

  useEffect(() => {
    setIsBackLink(false);
  }, []);

  return (
    <div>
      <PageHeader title='Dashboard 🚀' subtitle='Monitor your team’s spending here' />
      <div>
        <MainDashboard
          loading={monthlyStatLoading}
          balance={companyWalletDetails?.available_balance.toString()}
          orders={monthlyStat?.orders_count}
        />
      </div>
      <div className='w-full md:flex '>
        <div className='basis-2/3 mt-12'>
          <TransactionChart dateRange={dateRange} setDateRange={setDateRange} />
        </div>
        <div className='basis-1/3 mt-6'>
          <Insight dateRange={dateRange} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
